import * as type from '../../../actions/index.types';
import webTokenStorer, { selectedSocietyStorer } from '../../../../utils/webStorer';

const persistedSociety = selectedSocietyStorer.getUserSocietydata?.() || null;
// On a hard reload with an existing session, the app immediately re-fetches
// permissions (relogin → /my-permissions). Start in the loading state so route
// guards render a spinner instead of flashing "Access Denied" before perms arrive.
const hasSession = !!webTokenStorer.getToken?.();

const initialState = {
  // C1 my-societies
  societiesLoading: false,
  mySocieties: null,

  // C2 my-permissions for active society
  permissionsLoading: hasSession,
  permissions: [],
  activeRole: null,

  // Currently active society (rehydrated from localStorage on boot)
  activeSociety: persistedSociety,

  // C3 society users list
  usersLoading: false,
  societyUsersData: null,
  usersPagination: null,

  // C4–C6 mutation flags
  assignLoading: false,
  updateLoading: false,
  removeLoading: false,

  error: null,
};

export function UserSocietyReducer(state = initialState, action) {
  switch (action.type) {
    case type.GET_MY_SOCIETIES:
      return { ...state, societiesLoading: true, error: null };
    case type.GET_MY_SOCIETIES_SUCCESS:
      return { ...state, societiesLoading: false, mySocieties: action.payload?.data };
    case type.GET_MY_SOCIETIES_FAILURE:
      return { ...state, societiesLoading: false, error: action?.message || 'Something went wrong.' };

    case type.GET_MY_PERMISSIONS:
      return { ...state, permissionsLoading: true, error: null };
    case type.GET_MY_PERMISSIONS_SUCCESS:
      return {
        ...state,
        permissionsLoading: false,
        permissions: action.payload?.permissions || [],
        activeRole: action.payload?.role || null,
      };
    case type.GET_MY_PERMISSIONS_FAILURE:
      return {
        ...state,
        permissionsLoading: false,
        permissions: [],
        activeRole: null,
        error: action?.message || 'Something went wrong.',
      };

    case type.SET_ACTIVE_SOCIETY:
      return { ...state, activeSociety: action.data };
    case type.CLEAR_ACTIVE_SOCIETY:
      return { ...state, activeSociety: null, permissions: [], activeRole: null };

    case type.GET_SOCIETY_USERS:
      return { ...state, usersLoading: true, error: null };
    case type.GET_SOCIETY_USERS_SUCCESS:
      return {
        ...state,
        usersLoading: false,
        societyUsersData: action.payload?.data,
        usersPagination: action.payload?.meta?.pagination,
      };
    case type.GET_SOCIETY_USERS_FAILURE:
      return { ...state, usersLoading: false, error: action?.message || 'Something went wrong.' };

    case type.CREATE_USER_SOCIETY:
      return { ...state, assignLoading: true, error: null };
    case type.CREATE_USER_SOCIETY_SUCCESS:
      return { ...state, assignLoading: false };
    case type.CREATE_USER_SOCIETY_FAILURE:
      return { ...state, assignLoading: false, error: action?.message || 'Something went wrong.' };

    case type.UPDATE_USER_SOCIETY:
      return { ...state, updateLoading: true, error: null };
    case type.UPDATE_USER_SOCIETY_SUCCESS:
      return { ...state, updateLoading: false };
    case type.UPDATE_USER_SOCIETY_FAILURE:
      return { ...state, updateLoading: false, error: action?.message || 'Something went wrong.' };

    case type.DELETE_USER_SOCIETY:
      return { ...state, removeLoading: true, error: null };
    case type.DELETE_USER_SOCIETY_SUCCESS:
      return { ...state, removeLoading: false };
    case type.DELETE_USER_SOCIETY_FAILURE:
      return { ...state, removeLoading: false, error: action?.message || 'Something went wrong.' };

    default:
      return state;
  }
}
